var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1366,0 L1366,768 L0,768 L0,0 L1366,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.03,2.92750482 C18.12,4.01750482 18.93,5.32750482 19.42,6.74750482 C19.63,7.35750482 19.16,7.99750482 18.51,7.99750482 L18.41,7.99750482 C17.99,7.99750482 17.64,7.71750482 17.5,7.32750482 C17.11,6.21750482 16.48,5.19750482 15.62,4.33750482 C12.51,1.22750482 7.44,1.21750482 4.32,4.31750482 L6.29,6.28750482 C6.92,6.91750482 6.47,7.99750482 5.58,7.99750482 L1,7.99750482 C0.45,7.99750482 0,7.54750482 0,6.99750482 L0,2.40750482 C0,1.51750482 1.08,1.06750482 1.71,1.69750482 L2.91,2.90750482 C6.81,-0.97249518 13.14,-0.97249518 17.03,2.92750482 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1121.0 -88.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.0 72.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(774.9999999999999 15.999999999999062)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4899999999997817 8.002495179942343)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-4.4408921e-16 19.4706578,-4.4408921e-16 19.4706578,7.99750482 0,7.99750482 0,-4.4408921e-16",
    stroke: "none",
    fill: "#4A5DE2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.7f766f8e48f12716b3c7b23162c3f703.svg";
export { ForwardRef as ReactComponent };